//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date :14/12/2023
// Version : 1
// Description : Pantalla para ver los reclamos segun sean : *Pendientes, *Asignados o *Finalizados.
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date :11-3-2024
// Change by : Magali Perea
// Change description:
//  - Se añadió la propiedad "size" a algunas columnas de la tabla.
//  - Se añadió la modificación a los detalles del reclamo.
//  - Se amplió la longitud de "detalles" a 500 caracteres en el alta de un nuevo reclamo
//  - Se quitó la opción para cambiar directamente el "a cargo", ya que ahora está incluida en la edición.
//  - Se añade la columna "instaladores" y se quitó la de "a cargo"
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../../services/apirest";
import { Typography, ListItemIcon, MenuItem } from "@mui/material";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import { AlignHorizontalLeft, Build } from "@mui/icons-material";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import MaterialReactTable from "material-react-table";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import moment from "moment";
import AsignarTecnico from "./AsignarTecnico";
import Detallereclamo from "./DetalleReclamo";
import FinalizarReclamo from "./FinalizarReclamo";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import CancelarReclamo from "./CancelarReclamo";
import EditIcon from "@mui/icons-material/Edit";
import AttachFileIcon from "@mui/icons-material/AttachFile"; //ADJUNTAR
import FileUploadReclamo from "./FileUploadReclamo"; //ADJUNTAR
import { v4 as uuidv4 } from "uuid";
import EditarReclamo from "./EditarReclamo";
import ReceiptIcon from "@mui/icons-material/Receipt";
import Facturado from "./Facturado";
import Badge from "@mui/material/Badge";

export default function Reclamos(props) {
  const [uuid, setUuid] = useState(uuidv4());
  const [reclamos, setReclamos] = useState();
  const [tabla, setTabla] = useState(true);
  const globalTheme = useTheme();
  const [asignar, setAsignar] = useState(false);
  const [dataReclamo, setDataReclamo] = useState({});
  const [finalizar, setFinalizar] = useState(false);
  const [cancelar, setCancelar] = useState(false);
  const [showEditar, setShowEditar] = useState(false);
  const [facturar, setFacturar] = useState(false);
  const [activeTab, setActiveTab] = useState(props.activeTab);
  const [newUuid, setNewUuid] = useState(""); //ADJUNTAR COMPROBANTE
  const [openCloseAdj, setOpenCloseAdj] = useState(false); //ADJUNTAR COMPROBANTE
  const [pagination, setPagination] = useState({
    pageIndex: 0, // página inicial
    pageSize: 10, // filas por página
  });
  const handleOpenCloseAdj = (value) => {
    setOpenCloseAdj(value);
    getReclamos();
  };

  const handleCloseFacturar = (value) => {
    setFacturar(false);
    getReclamos();
  };

  const obtenerReclamos = (estado) => {
    const sucComercial = localStorage.getItem("sucursal");

    const url =
      localStorage.getItem("sector") === "13"
        ? `${UrlApi}/reclamos/suc_comercial/${estado}/${sucComercial}`
        : `${UrlApi}/reclamos/estadoContadorDeAdjuntos/${estado}`;

    fetch(url)
      .then((data) => data.json())
      .then((data) => setReclamos(data))
      .catch((error) => console.error("Error al obtener reclamos:", error));
  };

  const getReclamos = () => {
    switch (props.activeTab) {
      case 0:
        obtenerReclamos(192);
        break;

      case 1:
        const estados = [170, 342];
        const estadosStr = estados.join(",");
        obtenerReclamos(estadosStr);
        break;

      case 2:
        obtenerReclamos(171);
        break;

      case 3:
        obtenerReclamos(223);
        break;

      default:
        console.log("Error");
        break;
    }
  };

  useEffect(() => {
    getReclamos();
  }, [props.activeTab, tabla]);

  // PARA LOS ESTADOS 170 (asignado), 223 (cancelado)
  const getColumns = (reclamos) => {
    let columns = [
      {
        header: "OT",
        accessorKey: "idreclamo",
        maxSize: 50,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Cliente",
        accessorFn: (row) => `${row.sisven_id} - ${row.razon_social}`,
        size: 340,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Registrado",
        accessorKey: "created_at",
        sortingFn: "datetime",
        Cell: ({ cell }) => moment(cell.getValue()).format("DD-MM-YYYY"),
        size: 90,
        muiTableBodyCellProps: { align: "center" },
      },
      {
        header: "Prioridad",
        accessorKey: "valor_prioridad",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Motivo",
        accessorKey: "descripcion_motivo",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Instalador",
        accessorKey: "proveedor",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Planta",
        accessorKey: "nombre_suc",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
    ];
    return columns;
  };

  const columns = useMemo(() => getColumns(reclamos), [reclamos]);

  // PARA EL ESTADO 171 (finalizado)
  const getColumns3 = (reclamos) => {
    let columns3 = [
      {
        header: "OT",
        accessorKey: "idreclamo",
        maxSize: 50,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Cliente",
        accessorFn: (row) => `${row.sisven_id} - ${row.razon_social}`,
        size: 340,
        muiTableBodyCellProps: { align: "left" },
      },

      {
        header: "Registrado",
        accessorKey: "created_at",
        sortingFn: "datetime",
        Cell: ({ cell }) => moment(cell.getValue()).format("DD-MM-YYYY"),
        size: 90,
        muiTableBodyCellProps: { align: "center" },
      },
      {
        header: "Prioridad",
        accessorKey: "valor_prioridad",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Motivo",
        accessorKey: "descripcion_motivo",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Instalador",
        accessorKey: "proveedor",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Finalizado",
        accessorKey: "fecha_finalizado",
        sortingFn: (rowA, rowB, columnId) => {
          const a = rowA.getValue(columnId);
          const b = rowB.getValue(columnId);

          if (!a && !b) return 0;
          if (!a) return 1; // null abajo
          if (!b) return -1;

          return new Date(a) - new Date(b);
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? moment(value).format("DD-MM-YYYY") : "—";
        },
        size: 90,
        muiTableBodyCellProps: { align: "center" },
      },
      {
        header: "Facturado",
        accessorKey: "facturado",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Planta",
        accessorKey: "nombre_suc",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
    ];
    return columns3;
  };

  const column3 = useMemo(() => getColumns3(reclamos), [reclamos]);

  // PARA LOS ESTADOS 192 (pendiente)
  const getColumns1 = (reclamos) => {
    let columns1 = [
      {
        header: "OT",
        accessorKey: "idreclamo",
        maxSize: 50,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Cliente",
        accessorFn: (row) => `${row.sisven_id} - ${row.razon_social}`,
        size: 340,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Registrado",
        accessorKey: "created_at",
        sortingFn: "datetime",
        Cell: ({ cell }) => moment(cell.getValue()).format("DD-MM-YYYY"),
        size: 90,
        muiTableBodyCellProps: { align: "center" },
      },
      {
        header: "Prioridad",
        accessorKey: "valor_prioridad",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Motivo",
        accessorKey: "descripcion_motivo",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Planta",
        accessorKey: "nombre_suc",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
    ];
    return columns1;
  };

  const columns1 = useMemo(() => getColumns1(reclamos), [reclamos]);

  useEffect(() => {
    if (dataReclamo?.idreclamo) {
      const actualizado = reclamos.find(
        (r) => r.idreclamo === dataReclamo.idreclamo,
      );
      if (actualizado) setDataReclamo(actualizado);
    }
  }, [reclamos]);

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    sorting: [{ id: "idreclamo", desc: true }],
    columnPinning: { right: ["mrt-row-actions"] },
  };

  const tableHeadCellProps = {
    align: "center",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme],
  );

  let filteredColumns = [];
  if (reclamos) {
    if (props.activeTab === 1 || props.activeTab === 3) {
      filteredColumns = columns;
    } else if (props.activeTab === 2) {
      filteredColumns = column3;
    } else if (props.activeTab === 0) {
      filteredColumns = columns1;
    }
  }

  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };

  return (
    <div>
      {tabla && reclamos ? (
        <ThemeProvider theme={tableTheme}>
          <MaterialReactTable
            state={{
              pagination,
            }}
            onPaginationChange={setPagination}
            autoResetPageIndex={false} //evitar reseteo tara ##388
            enableRowActions={localStorage.getItem("sector") !== "13"} // solo activa si no es sector 13
            enableColumnResizing
            enableFacetedValues
            getRowId={(row) => row.idreclamo}
            columns={filteredColumns}
            data={reclamos}
            initialState={initialState}
            positionActionsColumn="last"
            enableExpandAll={false}
            enableToolbarInternalActions={true}
            muiTableHeadCellProps={tableHeadCellProps}
            muiTableBodyCellProps={({ row }) => ({
              // align: "left",
            })}
            enableColumnActions={false}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={false}
            layoutMode="grid"
            localization={customLocalization}
            enableSorting
            enableColumnDragging={false}
            enablePinning={false}
            enableHiding={false}
            enableColumnFilters={true}
            renderDetailPanel={({ row }) => (
              <Detallereclamo
                datos={row.original}
                activeTab={activeTab}
                row={row}
              />
            )}
            renderTopToolbarCustomActions={() => (
              <>
                <Typography variant="poster" fontSize={26}>
                  Reclamos
                </Typography>
              </>
            )}
            renderRowActionMenuItems={({ closeMenu, row }) =>
              localStorage.getItem("sector") === "13"
                ? [] // si es sector 13 no renderiza nada
                : [
                    <MenuItem
                      disabled={
                        row.original.estado === 170 ||
                        row.original.estado === 171 ||
                        row.original.estado === 223 ||
                        row.original.estado === 342
                      }
                      key={0}
                      onClick={() => {
                        closeMenu();
                        setDataReclamo(row.original);
                        setAsignar(true);
                        setUuid(uuidv4());
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <Build color="action" />
                      </ListItemIcon>
                      Asignar Técnico
                    </MenuItem>,

                    <MenuItem
                      disabled={row.original.estado !== 170}
                      key={1}
                      onClick={() => {
                        closeMenu();
                        setDataReclamo(row.original);
                        setAsignar(true);
                        setUuid(uuidv4());
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <Build color="action" />
                      </ListItemIcon>
                      Reasignar Técnico
                    </MenuItem>,

                    <MenuItem
                      disabled={
                        row.original.estado !== 170 &&
                        row.original.estado !== 342
                      }
                      key={2}
                      onClick={() => {
                        setDataReclamo(row.original);
                        setFinalizar(true);
                        closeMenu();
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <BeenhereIcon color="success" />
                      </ListItemIcon>
                      Finalizar
                    </MenuItem>,

                    <MenuItem
                      disabled={
                        row.original.estado === 171 ||
                        row.original.estado === 223 ||
                        (row.original.estado === 170 &&
                          localStorage.getItem("sector") === "13")
                      }
                      key={3}
                      onClick={() => {
                        closeMenu();
                        setDataReclamo(row.original);
                        setCancelar(true);
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <DoDisturbAltIcon color="error" />
                      </ListItemIcon>
                      Cancelar
                    </MenuItem>,

                    <Badge
                      key={4}
                      color="primary"
                      badgeContent={row.original.total_archivos} // Muestra el número correcto de adjuntos
                      showZero
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      sx={{
                        "& .MuiBadge-badge": {
                          fontSize: "0.75rem", // Tamaño de fuente más pequeño
                          minWidth: "17px", // Ancho mínimo del badge
                          height: "17px", // Alto mínimo del badge
                          padding: "0 3px", // Padding ajustado para el contenido
                          transform: "translateX(32px)", // Desplaza el badge hacia la derecha
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          setNewUuid(row.original.uuid);
                          setOpenCloseAdj(!openCloseAdj);
                          closeMenu();
                        }}
                      >
                        <ListItemIcon>
                          <AttachFileIcon color="action" />
                        </ListItemIcon>
                        Adjuntos
                      </MenuItem>
                    </Badge>,

                    <MenuItem
                      disabled={
                        row.original.estado === 171 ||
                        row.original.estado === 223 ||
                        localStorage.getItem("sector") === "13" // condición del sector (comercial granel no puede verlo)
                      }
                      key={5}
                      onClick={() => {
                        setDataReclamo(row.original);
                        setShowEditar(true);
                        closeMenu();
                      }}
                    >
                      <ListItemIcon>
                        <EditIcon color="action" />
                      </ListItemIcon>
                      Editar
                    </MenuItem>,

                    <MenuItem
                      disabled={
                        row.original.estado !== 171 ||
                        localStorage.getItem("sector") === "13" // condición del sector (comercial granel no puede verlo)
                      }
                      key={6}
                      onClick={() => {
                        setDataReclamo(row.original);
                        setFacturar(true);
                        closeMenu();
                      }}
                    >
                      <ListItemIcon>
                        <ReceiptIcon color="secondary" />
                      </ListItemIcon>
                      Facturar
                    </MenuItem>,
                  ]
            }
          />
        </ThemeProvider>
      ) : null}
      {asignar ? (
        <AsignarTecnico
          datos={dataReclamo}
          open={asignar} // Pasa el estado booleano
          setOpen={setAsignar} // Pasa la función para actualizar el estado
          tabla={setTabla}
          actualizar={getReclamos}
          uuid={uuid}
          activeTab={activeTab}
        />
      ) : null}
      {finalizar ? (
        <FinalizarReclamo
          key={`${dataReclamo.idreclamo}_${dataReclamo.total_archivos}`}
          datos={dataReclamo}
          open={finalizar} // Pasa el estado booleano
          setOpen={setFinalizar} // Pasa la función para actualizar el estado
          tabla={setTabla}
          actualizar={() => getReclamos()}
        />
      ) : null}
      {cancelar ? (
        <CancelarReclamo
          datos={dataReclamo}
          open={cancelar} // Pasa el estado booleano
          setOpen={setCancelar} // Pasa la función para actualizar el estado
          tabla={setTabla}
          actualizar={getReclamos}
        />
      ) : null}
      {openCloseAdj ? ( // ADJUNTAR COMPROBANTES
        <FileUploadReclamo
          fileId={newUuid}
          openclose={true}
          mostrar={true}
          onClose={() => handleOpenCloseAdj(false)} // Proporciona una función de cierre
          onFileUpload={() => console.log("Archivo guardado")}
          onDeleteFile={() => console.log("Archivo borrado")}
        />
      ) : null}
      {showEditar ? (
        <EditarReclamo
          datos={dataReclamo}
          open={showEditar}
          setOpen={setShowEditar}
          actualizar={getReclamos}
        />
      ) : null}
      {facturar ? (
        <Facturado
          datos={dataReclamo}
          open={facturar} // Pasa el estado booleano
          setOpen={setFacturar} // Pasa la función para actualizar el estado
          tabla={setTabla}
          actualizar={getReclamos}
          onClose={handleCloseFacturar}
        />
      ) : null}
      <br></br>
      <br></br>
    </div>
  );
}
